import { getItemMaker } from "./tools";

const i = getItemMaker("special talent books");
export const specialTalentBooks = [
  // TalentBook1
  i("Action Frenzy (Special Talent Book)"),
  i("American Tipper (Special Talent Book)"),
  i("Attacks On Simmer (Special Talent Book)"),
  i("Beginner Best Class (Special Talent Book)"),
  i("Bored To Death (Special Talent Book)"),
  i("Boss Battle Spillover (Special Talent Book)"),
  i("Cardiovascular! (Special Talent Book)"),
  i("Cash Money (Special Talent Book)"),
  i("Coins for Charon (Special Talent Book)"),
  i("Crystals 4 Dayys (Special Talent Book)"),
  i("Dreamer Damage (Special Talent Book)"),
  i("Dummy Thicc Stats (Special Talent Book)"),
  i("Dungeonic Damage (Special Talent Book)"),
  i("Exp Converter (Special Talent Book)"),
  i("Filthy Damage (Special Talent Book)"),
  i("Frothy Malk (Special Talent Book)"),
  i("Just Exp (Special Talent Book)"),
  i("Mega Crit (Special Talent Book)"),
  i("Milkyway Candies (Special Talent Book)"),
  i("Monolithialism (Special Talent Book)"),
  i("Overaccurate Crit (Special Talent Book)"),
  i("Printer Sampling (Special Talent Book)"),
  i("Pulsation (Special Talent Book)"),
  i("Quest Chungus (Special Talent Book)"),
  i("Rando Event Looty (Special Talent Book)"),
  i("Roll Da Dice (Special Talent Book)"),
  i("Shrine Architect (Special Talent Book)"),
  i("Stonks! (Special Talent Book)"),
  i("Studious Quester (Special Talent Book)"),
  i("Supersource (Special Talent Book)"),
  i("Tick Tock (Special Talent Book)"),
  i("Tiptoe Quickness (Special Talent Book)"),
  i("Toilet Paper Postage (Special Talent Book)"),
  i("Ubercharged Health (Special Talent Book)"),
  i("Will of the Eldest (Special Talent Book)"),
];
